import React from 'react';
import { Tooltip, IconButton } from '@mui/material';

const SimpleIcon = ({ title, onClick, colorState, IconComponent, ...props }) => {
    return (
        <Tooltip title={title} {...props}>
            <IconButton onClick={onClick} color={colorState?'primary':'default'}>
                <IconComponent />
            </IconButton>
        </Tooltip>
    )
}

export default SimpleIcon;
